import { render, staticRenderFns } from "./ModalCalculationForm.vue?vue&type=template&id=71e35659&scoped=true"
import script from "./ModalCalculationForm.vue?vue&type=script&lang=js"
export * from "./ModalCalculationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e35659",
  null
  
)

export default component.exports